import { component } from 'picoapp';

export default component((node, ctx) => {
  window.slater = {
    toggleForm: (id) => {
      $(`#form_${id}`).slideToggle();
    },

    toggleNewForm: function () {
      var el = document.getElementById('form_new');
      el.style.display = el.style.display == 'none' ? '' : 'none';
    },

    removeAddress: function removeAddress(id) {
      if (!confirm('Are you sure you wish to delete this address?')) return;

      var form = document.createElement('form');
      var input = document.createElement('input');

      form.setAttribute('method', 'post');
      form.setAttribute('action', '/account/addresses/' + id);

      input.setAttribute('type', 'hidden');
      input.setAttribute('name', '_method');
      input.setAttribute('value', 'delete');

      form.appendChild(input);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    }
  };



});